export default __webpack_public_path__ + "static/media/icon-prev-dark.5589cc10.svg";